import { StateInterface } from "./state";
import { ProjectModel } from "../models";

export const setProjectsHandle = "setProjects";
export const setSubscriptionsHandle = "setSubscriptions";

export default {
  [setProjectsHandle](state: StateInterface, projects: ProjectModel[]): void {
    state.projects = projects;
  },
  [setSubscriptionsHandle](
    state: StateInterface,
    projects: ProjectModel[]
  ): void {
    state.subscriptions = projects;
  },
};
